<oaibox-warning-message-card gradient="danger" confirmText="Delete" (confirm$)="confirm()" (cancel$)="cancel()">
  <div messageTitle>Are you sure you want to delete the machine?</div>
  <div messageBody class="d-flex g-g justify-content-center align-items-center p-g pb-0">
    <div class="ellipsis">
      <div class="tenant-name">{{tenant?.clientName}}</div>
      <div class="under-label ellipsis">{{tenant?.clientDescription}}</div>
    </div>
    <div class="d-flex align-items-center">
      <i class="fa-solid fa-square-minus danger"></i>
      <div class="oaibox-container">
        <oaibox-custom-i class="oaibox-icon danger" icon="box-inverted" iconsBasePath="assets/icons/duotone"></oaibox-custom-i>
        <div>
          <div class="oaibox-type">{{machine?.productDetails?.oaiboxType ?? 'OAIBOX'}}</div>
          <div class="machine-id under-label">{{machine?.id}}</div>
        </div>
      </div>
    </div>
  </div>
</oaibox-warning-message-card>
